// extracted by mini-css-extract-plugin
export var askAiIcon = "_qr-9";
export var container = "_qr-0";
export var groupSeparator = "_qr-a";
export var highlight = "_qr-4";
export var resultIcon = "_qr-5";
export var resultItem = "_qr-7";
export var resultSubtitle = "_qr-3";
export var resultTitle = "_qr-2";
export var resultsList = "_qr-1";
export var searchGroup = "_qr-6";
export var selected = "_qr-8";